export default {
  empty_list: 'Brak kategorii',
  uses_restaurant_open_times: 'Używa godzin otwarcia restauracji',
  products_creation_disabled:
    'Ze względu na aktywną integrację z {{integration}}, tworzenie nowych produktów jest niedozwolone. Aby zmienić menu, wprowadź zmiany w {{integration}} i zsynchronizuj menu.',
  buttons: {
    add_category: 'Dodaj kategorię',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak',
  },
};
